export enum Palette {
  WASH_ME = '#F5F5F5',
  CHEFS_HAT = '#F2F5F7',
  BLACK_OUT = '#1F242C',
  BLACK_OUT_ALPHA_40 = '#1F242C66',
  BLACK_OUT_ALPHA_50 = '#1F242C80',
  GOSHAWK_GREY = '#2A2F37',
  GOSHAWK_GREY_ALPHA_40 = '#2A2F3766',
  GOSHAWK_GREY_ALPHA_50 = '#2A2F3780',
  GOSHAWK_GREY_ALPHA_60 = '#2A2F3799',
  GOSHAWK_GREY_ALPHA_70 = '#2A2F37B3',
  BRIGHT_GREY_2 = '#DFE3E8',
  BRIGHT_GREY = '#ECEDF0',
  VIOLET_HEAVEN_ALPHA = '#d5ddff',
  VIOLET_HEAVEN = '#C8B9F9',
  HAN_PURPLE = '#36BBAF',
  HAN_BLUE_LIGHT = '#75E1D7',
  DANGER = '#DC2626',
  WHITE = '#FFFFFF',
  MIST_WHISPER = '#EAEAEA',
  DEEP_SEA_BLUE = '#1b3a4b',
  CORAL_REEF_GREEN = '#27827A',
  BLACK = '#000000',
  ONYX_BLACK = '#1D1D1D',
  SMOKY_SLATE = '#6E6E73',
  DARK_ONYX = '#161616',
  OLIVE_GREEN = '#16A34A',
  GOLDEN_ORANGE = '#F59E0B',
}

export const PaletteMix = [
  '#eee8ff', '#eeffea',
]

export enum RadiusTokens {
  pill = '999px',
}

// We can remove the Palette and update the palette to ColorTokens by default //
export enum ColorTokens {
  // Primary //
  primary10 = '#36BBAF1A',
  primary100 = '#B9EBE6',
  primary200 = '#74D7CE',
  primary300 = '#36BBAF',
  primary400 = '#2A9188',
  primary500 = '#1E6761',
  // Secondary //
  secondary10 = '#1B3A4B1A',
  secondary100 = '#9BC4DB',
  secondary200 = '#69A7C9',
  secondary300 = '#3F87AF',
  secondary400 = '#2D617D',
  secondary500 = '#1B3A4B',
  // Neutral //
  neutral10 = '#3333331A',
  neutral100 = '#FFFFFF',
  neutral200 = '#E8E8E8',
  neutral300 = '#D2D2D2',
  neutral400 = '#BBBBBB',
  neutral500 = '#A4A4A4',
  neutral600 = '#8E8E8E',
  neutral700 = '#777777',
  neutral800 = '#606060',
  neutral900 = '#4A4A4A',
  neutral1000 = '#333333',
  // Border //
  border100 = '#D9D9D9',
  // Red //
  red10 = '#FB37481A',
  red100 = '#FB3748',
  red200 = '#D00416',
  // Yellow //
  yellow10 = '#FFDB431A',
  yellow100 = '#FFDB43',
  yellow200 = '#DFB400',
  // Green //
  green10 = '#1FC16B1A',
  green100 = '#84EBB4',
  green200 = '#1FC16B',
}
